import { useState, useMemo } from 'react';

/**
 * Custom hook for message text truncation
 * @param {string} text - The raw message text
 * @param {number} limit - Character limit for truncation (default 300)
 * @returns {Object} Truncation state and handlers
 */
export const useMessageTruncation = (text = '', limit = 300) => {
   const [isExpanded, setIsExpanded] = useState(false);

   const { isTruncated, displayText } = useMemo(() => {
      const isTruncated = text.length > limit;
      const displayText = !isExpanded && isTruncated ? `${text.substring(0, limit)}...` : text;
      return { isTruncated, displayText };
   }, [text, limit, isExpanded]);

   const toggleExpand = e => {
      e?.preventDefault();
      e?.stopPropagation();
      setIsExpanded(prev => !prev);
   };

   return {
      isTruncated,
      isExpanded,
      displayText,
      toggleExpand,
   };
};
